/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import { forwardRef } from "react";
import PropTypes from "prop-types";
import OGButtonRoot from "assets/theme/components/OGButton/OGButtonRoot";
import { useThemeUIController } from "context";

const OGButton = forwardRef(
  ({ color, variant, size, circular, iconOnly, children, ...rest }, ref) => {
    const [controller] = useThemeUIController();
    const { darkMode } = controller;

    return (
      <OGButtonRoot
        {...rest}
        ref={ref}
        color="primary"
        variant={variant === "gradient" ? "contained" : variant}
        size={size}
        ownerState={{ color, variant, size, circular, iconOnly, darkMode }}
      >
        {children}
      </OGButtonRoot>
    );
  }
);

OGButton.defaultProps = {
  size: "medium",
  variant: "contained",
  color: "white",
  circular: false,
  iconOnly: false,
};

OGButton.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),
  variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient", "custom", "selected"]),
  color: PropTypes.oneOf(["light", "dark", "grey250", "grey650", "green", "red", "white"]),
  circular: PropTypes.bool,
  iconOnly: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default OGButton;
